<div class="row">
  <!-- Visa Type Grid -->
  <div class="col-md-12">
    <h2 class="content-block">
      <i class="fa-solid fa-passport"></i> Vize Süresi
    </h2>
    <dx-data-grid
      [dataSource]="visaTypes"
      class="content-block card responsive-paddings"
      keyExpr="id"
      (onRowInserting)="createVisaType($event)"
      (onRowUpdating)="updateVisaType($event)"
      (onRowRemoved)="deleteVisaType($event)"
      (onInitNewRow)="onInitNewRow($event)"
    >
      <dxo-editing
        mode="row"
        [allowUpdating]="true"
        [allowDeleting]="true"
        [allowAdding]="true"
      ></dxo-editing>
      <dxo-paging [enabled]="true" [pageSize]="5"></dxo-paging>
      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[5, 15, 25]"
        [showInfo]="true"
      ></dxo-pager>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column type="buttons" width="110">
        <dxi-button name="edit" icon="edit" hint="Düzenle"></dxi-button>
        <dxi-button name="delete" icon="trash" hint="Sil"></dxi-button>
      </dxi-column>
      <dxi-column dataField="name" caption="Adı">
        <dxi-validation-rule
          type="required"
          message="Vize Türü isteniyor"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="description" caption="Açıklama">
        <dxi-validation-rule
          type="required"
          message="Açıklama isteniyor"
        ></dxi-validation-rule>
      </dxi-column>
      <!-- VisaCountryId için Lookup Kullanımı -->
      <dxi-column dataField="visaCountryId" caption="Ülke">
        <dxo-lookup
          [dataSource]="countries"
          displayExpr="name"
          valueExpr="id"
        ></dxo-lookup>
        <dxi-validation-rule
          type="required"
          message="Ülke seçimi zorunludur"
        ></dxi-validation-rule>
      </dxi-column>

      <!-- Maliyet -->
      <dxi-column
        dataField="cost"
        caption="Maliyet"
        dataType="number"
        [calculateDisplayValue]="generateCost"
      >
        <dxi-validation-rule
          type="required"
          message="Maliyet girilmelidir"
        ></dxi-validation-rule>
      </dxi-column>

      <!-- Satış Tutarı -->
      <dxi-column
        dataField="saleAmount"
        caption="Satış "
        dataType="number"
        [calculateDisplayValue]="generateSaleAmount"
      >
        <dxi-validation-rule
          type="required"
          message="Satış Tutarı girilmelidir"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column
        dataField="cost_Under18"
        caption="18 yaş altı Maliyet"
        dataType="number"
        [calculateDisplayValue]="generateCostUnder18"
      >
          <dxi-validation-rule
          type="required"
          message="18 yaş altı maliyet girilmelidir"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column
        dataField="saleAmount_Under18"
        caption="18 yaş altı Satış"
        dataType="number"
        [calculateDisplayValue]="generateSaleAmountUnder18"
      >
            <dxi-validation-rule
          type="required"
          message="18 yaş altı satış girilmelidir"
        ></dxi-validation-rule>
      </dxi-column>

      <dxi-column
        dataField="isActive"
        caption="Aktif?"
        dataType="boolean"
      ></dxi-column>
    </dx-data-grid>
  </div>
</div>

<div class="row">
  <div class="col-md-6">
    <h2 class="content-block">
      <i class="fa-solid fa-passport"></i> Vize Aciliyeti
    </h2>
    <dx-data-grid
      [dataSource]="visaLevels"
      class="content-block card responsive-paddings"
      keyExpr="id"
      (onRowInserting)="createVisaLevel($event)"
      (onRowUpdating)="updateVisaLevel($event)"
      (onRowRemoved)="deleteVisaLevel($event)"
      (onInitNewRow)="onInitNewRow($event)"
    >
      <dxo-editing
        mode="row"
        [allowUpdating]="true"
        [allowDeleting]="true"
        [allowAdding]="true"
      ></dxo-editing>
      <dxo-paging [enabled]="true" [pageSize]="5"></dxo-paging>
      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[5, 15, 25]"
        [showInfo]="true"
      ></dxo-pager>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column type="buttons" width="110">
        <dxi-button name="edit" icon="edit" hint="Düzenle"></dxi-button>
        <dxi-button name="delete" icon="trash" hint="Sil"></dxi-button>
      </dxi-column>
      <dxi-column dataField="name" caption="Ad">
        <dxi-validation-rule
          type="required"
          message="Vize Aciliyeti adı isteniyor"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="description" caption="Açıklama">
        <dxi-validation-rule
          type="required"
          message="Açıklama isteniyor"
        ></dxi-validation-rule>
      </dxi-column>
      <!-- VisaCountryId için Lookup Kullanımı -->
      <dxi-column dataField="visaCountryId" caption="Ülke">
        <dxo-lookup
          [dataSource]="countries"
          displayExpr="name"
          valueExpr="id"
        ></dxo-lookup>
        <dxi-validation-rule
          type="required"
          message="Ülke seçimi zorunludur"
        ></dxi-validation-rule>
      </dxi-column>
      <!-- Maliyet -->
      <dxi-column
        dataField="cost"
        caption="Maliyet"
        dataType="number"
        [calculateDisplayValue]="generateCost"
      >
        <dxi-validation-rule
          type="required"
          message="Maliyet girilmelidir"
        ></dxi-validation-rule>
      </dxi-column>
      <!-- Satış Tutarı -->
      <dxi-column
        dataField="saleAmount"
        caption="Satış Tutarı"
        dataType="number"
        [calculateDisplayValue]="generateSaleAmount"
      >
        <dxi-validation-rule
          type="required"
          message="Satış Tutarı girilmelidir"
        ></dxi-validation-rule>
      </dxi-column>

      <dxi-column
        dataField="isActive"
        caption="Aktif?"
        dataType="boolean"
      ></dxi-column>
    </dx-data-grid>
  </div>
  <!-- Visit Reason Grid -->
  <div class="col-md-6">
    <h2 class="content-block">
      <i class="fa-solid fa-book"></i> Ziyaret Sebebi
      <i class="fa-solid fa-info-circle  " 
         title="Vize süresi ile fiyatlandırma yapılacak ülkeler için, maliyet ve satış girilmeden vize türü girilmelidir."></i>
    </h2>
    <dx-data-grid
      [dataSource]="visitReasons"
      class="content-block card responsive-paddings"
      keyExpr="id"
      (onRowInserting)="createVisitReason($event)"
      (onRowUpdating)="updateVisitReason($event)"
      (onRowRemoved)="deleteVisitReason($event)"
      (onInitNewRow)="onInitNewRow($event)"
    >
      <dxo-editing
        mode="row"
        [allowUpdating]="true"
        [allowDeleting]="true"
        [allowAdding]="true"
      ></dxo-editing>
      <dxo-paging [enabled]="true" [pageSize]="5"></dxo-paging>
      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[5, 15, 25]"
        [showInfo]="true"
      ></dxo-pager>
      <dxo-export [enabled]="false"></dxo-export>
      <dxi-column type="buttons" width="110">
        <dxi-button name="edit" icon="edit" hint="Düzenle"></dxi-button>
        <dxi-button name="delete" icon="trash" hint="Sil"></dxi-button>
      </dxi-column>
      <dxi-column dataField="name" caption="Ad">
        <dxi-validation-rule
          type="required"
          message="Ziyaret Sebebi adı isteniyor"
        ></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="description" caption="Açıklama">
        <dxi-validation-rule
          type="required"
          message="Açıklama isteniyor"
        ></dxi-validation-rule>
      </dxi-column>
      <!-- VisaCountryId için Lookup Kullanımı -->
      <dxi-column dataField="visaCountryId" caption="Ülke">
        <dxo-lookup
          [dataSource]="countries"
          displayExpr="name"
          valueExpr="id"
        ></dxo-lookup>
        <dxi-validation-rule
          type="required"
          message="Ülke seçimi zorunludur"
        ></dxi-validation-rule>
      </dxi-column>

      <!-- Maliyet -->
      <dxi-column
        dataField="cost"
        caption="Maliyet"
        dataType="number"
        [calculateDisplayValue]="generateCost"
      >
      </dxi-column>

      <!-- Satış Tutarı -->
      <dxi-column
        dataField="saleAmount"
        caption="Satış Tutarı"
        dataType="number"
        [calculateDisplayValue]="generateSaleAmount"
      >
        <dxi-validation-rule
          type="required"
          message="Satış Tutarı girilmelidir"
        ></dxi-validation-rule>
      </dxi-column>
            <dxi-column
        dataField="isActive"
        caption="Aktif?"
        dataType="boolean"
      ></dxi-column>


      </dx-data-grid>
  </div>
</div>

<div class="row">
 
      <!-- Pricing Category Grid -->
      <div class="col-md-12">
        <h2 class="content-block">
          <i class="fa-solid fa-money-bill-wave"></i> Fiyatlandırmalar
        </h2>
        <dx-data-grid
          [dataSource]="pricings"
          class="content-block card responsive-paddings"
          keyExpr="id"
          (onRowInserting)="createPricing($event)"
          (onRowUpdating)="updatePricing($event)"
          (onRowRemoved)="deletePricing($event)"
        >
          <dxo-editing
            mode="row"
            [allowUpdating]="true"
            [allowDeleting]="false"
            [allowAdding]="false"
          ></dxo-editing>

          <dxo-paging [enabled]="true" [pageSize]="5"></dxo-paging>
          <dxo-pager
            [showPageSizeSelector]="true"
            [allowedPageSizes]="[5, 15, 25]"
            [showInfo]="true"
          ></dxo-pager>

          <dxo-export [enabled]="false"></dxo-export>

          <!-- Butonlar (Düzenle/Sil) -->
          <dxi-column type="buttons" width="110">
            <dxi-button name="edit" icon="edit" hint="Düzenle"></dxi-button>
    
          </dxi-column>

          <dxi-column dataField="name" caption="Kategori" [allowEditing]="false">
            <dxi-validation-rule
              type="required"
              message="Kategori yazılması zorunludur"
            ></dxi-validation-rule>
          </dxi-column>

          <!-- Description -->
          <dxi-column dataField="description" caption="Açıklama">
            <dxi-validation-rule
              type="required"
              message="Açıklama bilgisi gereklidir"
            ></dxi-validation-rule>
          </dxi-column>

          <!-- Cost -->
          <dxi-column
            dataField="cost"
            caption="Maliyet"
            dataType="number"
            [calculateDisplayValue]="generateCost"
          >
            <dxi-validation-rule
              type="required"
              message="Maliyet gereklidir"
            ></dxi-validation-rule>
          </dxi-column>

          <!-- Sale Amount -->
          <dxi-column
            dataField="saleAmount"
            caption="Satış Tutarı"
            dataType="number"
            [calculateDisplayValue]="generateSaleAmount"
          >
            <dxi-validation-rule
              type="required"
              message="Satış tutarı gereklidir"
            ></dxi-validation-rule>
          </dxi-column>
        </dx-data-grid>
      </div>

    </div>


<div class="row">
  <div class="col-md-12">
    <h2 class="content-block">
      <i class="fa-solid fa-percent"></i> Vize İndirim Tanımları
    </h2>
    <dx-data-grid
      [dataSource]="discountRates"
      class="content-block card responsive-paddings"
      keyExpr="id"
      (onRowInserting)="createDiscountRate($event)"
      (onRowUpdating)="updateDiscountRate($event)"
      (onRowRemoved)="deleteDiscountRate($event)"
      (onEditorPreparing)="onEditorPreparing($event)"
    >
      <dxo-editing
        mode="row"
        [allowUpdating]="true"
        [allowDeleting]="true"
        [allowAdding]="true"
      ></dxo-editing>
      <dxo-paging [enabled]="true" [pageSize]="5"></dxo-paging>
      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[5, 15, 25, 50]"
        [showInfo]="true"
      ></dxo-pager>
      <dxo-export [enabled]="false"></dxo-export>

      <dxi-column type="buttons" width="110">
        <dxi-button name="edit" icon="edit" hint="Düzenle"></dxi-button>
        <dxi-button name="delete" icon="trash" hint="Sil"></dxi-button>
      </dxi-column>

      <!-- <dxi-column dataField="visaPriceDefinitionId" caption="Vize Türü">
          <dxo-lookup [dataSource]="visaPriceDefinitions" displayExpr="visaTypeName" valueExpr="id"></dxo-lookup>
          <dxi-validation-rule type="required" message="Vize Türü seçimi zorunludur"></dxi-validation-rule>
        </dxi-column> -->

      <dxi-column
        dataField="discountType"
        caption="İndirim Türü"
        [setCellValue]="setStateValue"
      >
        <dxo-lookup
          [dataSource]="discountTypes"
          displayExpr="label"
          valueExpr="value"
        >
        </dxo-lookup>
        <dxi-validation-rule
          type="required"
          message="İndirim Türü seçimi zorunludur"
        ></dxi-validation-rule>
      </dxi-column>

      <dxi-column dataField="numberOfPeople" caption="Kişi Sayısı">
        <dxo-lookup
          [dataSource]="getFilteredPersonCountOptions"
          displayExpr="label"
          valueExpr="value"
        >
        </dxo-lookup>
        <dxi-validation-rule
          type="required"
          message="Kişi sayısı girilmelidir"
        ></dxi-validation-rule>
      </dxi-column>

      <dxi-column
        dataField="discountRate"
        caption="İndirim Oranı (%)"
        dataType="number"
        [calculateCellValue]="calculateDiscountRate"
      >
        <dxi-validation-rule
          type="required"
          message="İndirim oranı girilmelidir"
        ></dxi-validation-rule>
      </dxi-column>
    </dx-data-grid>
  </div>
</div>
